import { ReactNode, useRef } from "react";
import useOutsideClick from "../../../../hooks/useOutsideClick";
import styles from "./UIModal.module.scss";
import { CloseCircleIcon } from "../../../../assets/icons";

interface Props {
	title?: string;
	onClose: (value: boolean) => void;
	onSubmit: () => void;
	children: ReactNode;
	btnTitle?: string;
}

const UIModal = (props: Props) => {
	const { title = "Select", btnTitle = "Confirm", onClose, onSubmit, children } = props;

	const dropdownRef = useRef<HTMLDivElement>(null);
	useOutsideClick({
		ref: dropdownRef,
		handler: () => {
			onClose(false);
		},
	});

	return (
		<div ref={dropdownRef} className={styles.popupModal}>
			<div className={styles.popupHeader}>
				<h2>{title}</h2>
				<div className={styles.closeIcon}>
					<CloseCircleIcon onClick={() => onClose(false)} />
				</div>
			</div>
			<div className={styles.popupBody}>{children}</div>
			<div className={styles.popupFooter}>
				<button className={`standardButton ${styles.declineButton}`} onClick={onSubmit}>
					{btnTitle}
				</button>
			</div>
		</div>
	);
};

export default UIModal;
